import { render, staticRenderFns } from "./ShikishaBetBetslip.vue?vue&type=template&id=f7b5f68c"
import script from "./ShikishaBetBetslip.vue?vue&type=script&lang=js"
export * from "./ShikishaBetBetslip.vue?vue&type=script&lang=js"
import style0 from "./ShikishaBetBetslip.vue?vue&type=style&index=0&id=f7b5f68c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports